import React from 'react';
import GenericFilter from './GenericFilter';

const LiveViewAreasFilter = (props) => <GenericFilter {...props} titleKey="areas" namePrefix="area" />;

export default LiveViewAreasFilter;
